module.exports = __webpack_public_path__ + "img/preferences.5c476efc.svg";